var _style, _polygon, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _ellipse3, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse4, _ellipse5, _ellipse6, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgButtonArt = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "ButtonArt",
  x: "0px",
  y: "0px",
  viewBox: "0 0 167.8 122.3",
  style: {
    enableBackground: "new 0 0 167.8 122.3"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.start0{fill:#334C56;}\r\n\t.start1{fill:#416F8C;}\r\n\t.start2{fill:#27393F;}\r\n\t.start3{fill:#53A6DC;}\r\n\t.start4{fill:url(#SVGID_1_a);}\r\n\t.start5{fill:url(#SVGID_2_a);}\r\n\t.start6{fill:url(#SVGID_3_a);}\r\n\t.start7{fill:url(#SVGID_4_a);}\r\n\t.start8{fill:url(#SVGID_5_a);}\r\n\t.start9{fill:#020303;}\r\n\t.start10{fill:url(#SVGID_6_a);}\r\n\t.start11{fill:url(#SVGID_7_a);}\r\n\t.start12{fill:url(#SVGID_8_a);}\r\n\t.start13{fill:url(#SVGID_9_a);}\r\n\t.start14{fill:url(#SVGID_10_a);}\r\n\t.start15{fill:url(#SVGID_11_a);}\r\n\t.start16{fill:url(#SVGID_12_a);}\r\n\t.start17{fill:#2B3033;}\r\n\t.start18{fill:url(#SVGID_13_a);}\r\n\t.start19{fill:url(#SVGID_14_a);}\r\n\t.start20{fill:url(#SVGID_15_a);}\r\n\t.start21{fill:url(#SVGID_16_a);}\r\n\t.start22{fill:url(#SVGID_17_a);}\r\n\t.start23{fill:url(#SVGID_18_a);}\r\n\t.start24{fill:url(#SVGID_19_a);}\r\n\t.start25{fill:url(#SVGID_20_a);}\r\n\t.start26{fill:url(#SVGID_21_a);}\r\n\t.start27{fill:url(#SVGID_22_a);}\r\n\t.start28{fill:url(#SVGID_23_a);}\r\n\t.start29{fill:url(#SVGID_24_a);}\r\n\t.start30{fill:url(#SVGID_25_a);}\r\n\t.start31{fill:url(#SVGID_26_a);}\r\n\t.start32{fill:url(#SVGID_27_a);}\r\n\t.start33{fill:url(#SVGID_28_a);}\r\n\t.start34{fill:url(#SVGID_29_a);}\r\n\t.start35{fill:url(#SVGID_30_a);}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  className: "start0",
  points: "27,30.4 8.8,43.3 14.1,56.9 28.8,44.9 "
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "start0",
  d: "M21.8,57.9c-3,14.3-27,31.6,5,42.1c0,0,6.3-8.1,16.9,0.7c0,0-2.5-16-15.5-12.5c0,0,2.5-3.3,6.5-3.4 c0,0-23.2-9.5-11.7-24.7C22.9,60.2,30.7,47.4,21.8,57.9z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "start1",
  d: "M147.4,23.9c0,0,13,4.3,19.6,35.5c0,0,4.8,27.7-9.3,41.6c0,0-4.4,4.2-5,9.5c0,0-3-6.4,1.7-18.6 c0,0-4.8,0-6.9,5.5c0,0-2-10.8,2.9-11.9c0,0-2-4.6-6-0.8c0,0,0.3-9.6,3.6-10.7c0,0-5.9-8.7-8.4-4.6c2.6-4.4,43.1,9.8,12.2-38.5 C150.5,28.8,147.4,23.9,147.4,23.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "start2",
  d: "M144.4,84.6c0,0,0.7-9.2,2.2-9.6C146.6,75.1,145.4,80.2,144.4,84.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "start0",
  d: "M153.9,35.3c2.4,12.7,21.2,28.1-3.9,37.5c0,0-4.9-7.2-13.3,0.6c0,0,2-14.3,12.2-11.1c0,0-2-3-5.1-3 c0,0,16.3-6.2,8.4-21.8C152.3,37.6,146.9,26,153.9,35.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "start3",
  d: "M136.7,73.5c0,0,6.8-8.1,13.3-0.6c0,0,10.8-4.3,12.2-9.4c0,0,2.2-4.9-1.7-12.7c0,0-7.7-14.2-7.2-16.1 c0,0-1.6-0.8-3-2.3c0,0-3.4-5.6,0.7-4.2c0,0,3.8,5.5,4.7,8.2c0,0,4.1,8.5,5,9.9c0,0,6.5,12.5,4.1,20.9c0,0-0.2,4.1-4.9,7.9 c0,0-4.5,3-5.6,8.5c0,0-1.4-6.1,0-7.5c0,0-6.1-0.1-8.1,4.2l0.1-5C146.4,75.3,147.2,70,136.7,73.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "start2",
  d: "M146.6,23.9l1.9,2.4c0,0-0.9,1.6,0,4.2c0,0,4.6,7.9,5.8,12.6c0,0,0.8,7.5-3.3,11.1c0,0-2,2.7-6.8,5.3 c0,0,5.9-1.8,7.5-4.3c0,0,4.2-3.5,3.6-12.1c0,0-2.8-9-4.7-11.3c0,0-2.5-2.2,0.3-2c0,0-2.1-0.8-1.6-1.8c0,0-0.2-0.9,1.6,0.3 c0,0-2.9-4.4-3.7-4.4L146.6,23.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "start2",
  d: "M148.9,62.4c0,0-9.5-4.4-12.2,11.1C136.7,73.5,138.9,63.3,148.9,62.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "start2",
  d: "M150.4,85.5c0,0-4.9-0.6-2.9,11.9C147.4,97.3,146.3,87.4,150.4,85.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "start2",
  d: "M152.7,110.5c0,0-3.1-6.3,1.7-18.6C154.4,91.9,151.2,102.6,152.7,110.5z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "start3",
  d: "M71.6,27.3c0,0-72.1-14.4-41.8,13.4c0,0,11.6,8.4-10.2,5c0,0,15.3,15,26,0c0,0-34.8,3.2-26,15.4 c0,0,5.4-10.1,23-7.1c0,0-19.9,2.1-19.1,11.1c0,0-11.5-1-4,13.1c0,0,4,5-2.5,7.4c0,0,14-0.7,13.4-9.6c0,0,3.6,13.9-10.8,15.4 c0,0,9.5,2.4,15.8-5.3c0,0,1.6,16,12.3,21.4c0,0-8.6-19.8,0.7-24.2c0,0,1.3,8.5,26.5,10.4L71,75.9L71.6,27.3z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "start3",
  d: "M147.8,39.8c4.2-9.8-2.9-14-2.9-14C134.8-2.1,90.7,0,88.1,0.1C85.4,0,41.4-2.1,31.3,25.8c0,0-7.2,4.1-2.9,14 c0,0-46.1,65.1,59.6,65.2v0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0v0C193.9,104.9,147.8,39.8,147.8,39.8z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "start1",
  d: "M154.7,47.2l2-2.7l-2.3-2.1v-2l-1.9-2.8c0,0-3.7-7.8-2.9-10.1c0.8-2.3,1.5,2.3-7.9-11.9 C132.1,1.4,96.5,0,96.5,0l-9.9,0L80,0C80,0,42.7,2.4,33,16.6c-9.6,14.2-8.9,9.6-8.1,11.9c0.8,2.3-3,10.1-3,10.1l-2,2.8v2l-2.4,2.1 l1.2,3.7c0,0-2.1,13.6,0.4,21.9c0,0,4.1,17.4,12.9,20.5c7.7,2.7,22.6,11.1,24.4,17.7c0.6,2.4,0.2,2.9,0.6,2.4 c3.5-5.2,1.8-10.7,1.8-10.7l12.6,9.5l1-6.3l15.7,4.7l0,0.1l0.1,0l0.1,0l0-0.1l15.3-4.7l1.6,4l11.8-7.2c0,0-1,5.5,1.8,10.7 c0,0,0.2-1.5,0.6-2.4c3-6,16.3-15,23.8-17.7c8.6-3.1,14.4-20.5,14.4-20.5C160.1,62.8,154.7,47.2,154.7,47.2z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_a",
  gradientUnits: "userSpaceOnUse",
  x1: 13.6267,
  y1: 60.4004,
  x2: 34.2659,
  y2: 60.4004,
  gradientTransform: "matrix(-1 0 0 1 49.4238 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.8791
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.659
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.3643
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009855568
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "start4",
  d: "M26,40.4c-1.8,0-1.3,2.4-2.1,2.5c0,0-0.7,2.4,0.4,3.5c0,0-1.5,1.1-2.5,0.5c0,0,1.4,3.4,2,3.5 c0,0-2.8-0.2-5,19.6c0,0,2.8,8.7,6.5,11.5c0,0,0.8,10.1,10.5,14.1c0,0-13.1-3.7-14.4-13.5c0,0-7.2-8.3-6.1-13.2 c0,0,1.6-19.5,4.5-20.3l-2-2.7l2.3-1.4l0-2.7l2-2.7l1.9-5.2c0,0,1.9-6.1,3-8.5C27.1,25.3,23.1,38.5,26,40.4z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  className: "start1",
  d: "M26,24.9c0,0-16.6,4.8-25,39.9c0,0-6.2,31.1,11.8,46.7c0,0,5.6,4.7,6.4,10.7c0,0,3.9-7.2-2.1-20.9 c0,0,6.2,0,8.8,6.2c0,0,2.5-12.1-3.7-13.4c0,0,2.5-5.1,7.6-0.9c0,0-0.4-10.7-4.6-12.1c0,0,7.5-9.8,10.7-5.1 c-3.3-4.9-54.9,11-15.5-43.3C22,30.5,26,24.9,26,24.9z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGID_2_a",
  cx: 98.6365,
  cy: 54.4124,
  r: 63.4318,
  gradientTransform: "matrix(0.8873 0 0 1 0 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#BDCAE7"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2721,
  style: {
    stopColor: "#C0CDE8",
    stopOpacity: 0.7279
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.505,
  style: {
    stopColor: "#CBD5EC",
    stopOpacity: 0.495
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7237,
  style: {
    stopColor: "#DDE3F2",
    stopOpacity: 0.2763
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9324,
  style: {
    stopColor: "#F5F7FB",
    stopOpacity: 0.06758821
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#FFFFFF",
    stopOpacity: 0
  }
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  className: "start5",
  d: "M119,107.4c0.8-7.5,14.7-18,21.9-20.5c8.2-2.9,10.4-19.1,10.4-19.1c2.4-7.7-5.4-22.3-5.4-22.3l1.9-2.6l-2.2-2 v-1.9l-1.9-2.6c0,0-3.5-7.3-2.8-9.4s1.4,2.2-7.6-11.1c-9-13.2-37.2-14.6-37.2-14.6l-9.5,0l-6.4,0c0,0-28.9,1.3-38.1,14.6 c-9.2,13.2-8.5,9-7.8,11.1c0.8,2.1-2.9,9.4-2.9,9.4l-1.9,2.6v1.9l-2.3,2l2,2.6c0,0-8,14.6-5.5,22.3c0,0,2.2,16.2,10.6,19.1 c7.4,2.5,21.4,10.4,23.3,20.5l0.6-9.7l12.2,9.6l1.8-5.7l15.9,4.4l0,0.1l0.1,0l0.1,0l0-0.1l15.5-4.4l1.8,2.7l12.7-6.6L119,107.4z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  className: "start2",
  d: "M76,54.8c0,16.4-12.5,31.8-23.2,31.8S33.4,73.3,33.4,57S49,23,59.7,23S76,38.4,76,54.8z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGID_3_a",
  cx: 61.6544,
  cy: 56.5823,
  r: 27.0163,
  gradientTransform: "matrix(0.8873 0 0 1 0 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5549,
  style: {
    stopColor: "#F3F3F3"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#E6E6E6"
  }
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  className: "start6",
  d: "M75.1,54.1c0,15.7-11.9,30.5-22.2,30.5S34.3,71.9,34.3,56.2s15-32.6,25.2-32.6S75.1,38.4,75.1,54.1z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGID_4_a",
  cx: 60.8963,
  cy: 61.6705,
  r: 17.2351,
  gradientTransform: "matrix(0.8873 0 0 1 0 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2828,
  style: {
    stopColor: "#F9F9F9"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4304,
  style: {
    stopColor: "#EBEBEC"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5467,
  style: {
    stopColor: "#D9D9DB"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6468,
  style: {
    stopColor: "#C2C3C7"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7364,
  style: {
    stopColor: "#A7A9AE"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8185,
  style: {
    stopColor: "#898C94"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8949,
  style: {
    stopColor: "#6A6F78"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9648,
  style: {
    stopColor: "#4A555E"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#384751"
  }
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  className: "start7",
  cx: 54,
  cy: 61.7,
  rx: 15.3,
  ry: 17.2
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGID_5_a",
  cx: 60.8482,
  cy: 61.5334,
  r: 14.349,
  gradientTransform: "matrix(0.8873 0 0 1 0 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.6609,
  style: {
    stopColor: "#2A3386"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.802,
  style: {
    stopColor: "#65A6DA"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8326,
  style: {
    stopColor: "#69A6D7"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8598,
  style: {
    stopColor: "#74A7CF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8858,
  style: {
    stopColor: "#84A8C4"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9111,
  style: {
    stopColor: "#97A9B4"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9358,
  style: {
    stopColor: "#AEAB9F"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9601,
  style: {
    stopColor: "#C8AD85"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9836,
  style: {
    stopColor: "#E4AE63"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#FBB040"
  }
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  className: "start8",
  cx: 54,
  cy: 61.5,
  rx: 12.7,
  ry: 14.3
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  className: "start9",
  cx: 53.7,
  cy: 61.4,
  rx: 8.6,
  ry: 9.7
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_6_a",
  gradientUnits: "userSpaceOnUse",
  x1: 48.9376,
  y1: 68.5533,
  x2: 53.7514,
  y2: 60.2155
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1026,
  style: {
    stopColor: "#F0F0F0",
    stopOpacity: 0.8974
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2446,
  style: {
    stopColor: "#E5E5E5",
    stopOpacity: 0.7554
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4447,
  style: {
    stopColor: "#DEDEDE",
    stopOpacity: 0.5553
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#DCDCDC",
    stopOpacity: 0
  }
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  className: "start10",
  d: "M47.1,56.3c0,0-2.5,5,0,10c0,0,2.6,4.1,6.7,3.8c0,0,2.4,0.3,4-1.3c0,0-5,0.6-6.4-1.1c0,0-1.7-0.6-3.5-3.6 C47.8,64.2,46.2,62.7,47.1,56.3z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGID_7_a",
  cx: 61.6544,
  cy: 54.0742,
  r: 27.0163,
  gradientTransform: "matrix(0.8873 0 0 1 0 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#FFFFFF",
    stopOpacity: 0.6
  }
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  className: "start11",
  d: "M75.1,54.1c0,15.7-11.9,30.5-22.2,30.5S34.3,71.9,34.3,56.2s15-32.6,25.2-32.6S75.1,38.4,75.1,54.1z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_8_a",
  gradientUnits: "userSpaceOnUse",
  x1: 52.0293,
  y1: 56.2543,
  x2: 59.6396,
  y2: 56.2543
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#DCDCDC",
    stopOpacity: 0
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#FFFFFF"
  }
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  className: "start12",
  d: "M52,52.7c0,0,3.2-1.2,6,1.3c0,0,1.6,1.4,1.6,3.2L57,60C57.5,55.8,53,53.2,52,52.7z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  className: "start2",
  d: "M34.6,52.4c0,0,9-10.2,42.4,3.7c0,0-2.7-48.2-9.3-48.2c0,0,1.2,6.5-0.5,9c0,0-0.7-2.7-2.2-4.1 c0,0-10.4,8.4-14,8C50.9,20.8,38.3,23.5,34.6,52.4z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  className: "start0",
  d: "M17.7,37.8c-3,14.3-27,31.6,5,42.1c0,0,6.3-8.1,16.9,0.7c0,0-2.5-16-15.5-12.5c0,0,2.5-3.3,6.5-3.4 c0,0-23.2-9.5-11.7-24.7C18.8,40.1,26.6,27.3,17.7,37.8z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  className: "start3",
  d: "M35.2,54.4c0,0,9.1-12.5,40.8,0.7c0,0-3.6-42.6-7-44c0,0,0.4,6-3,7.7c0,0,0.2-2.6-1.3-3.9c0,0-9.9,8-13.3,7.6 C51.4,22.5,38.8,26.9,35.2,54.4z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  className: "start0",
  d: "M88.3,65.8c0,0-17.1,1.3-18.9,16.8s18.9,14.8,18.9,14.8s25.2-4,20.4-15.8C108.7,81.7,104.2,63.9,88.3,65.8z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  className: "start3",
  d: "M88.1,66.5c0,0-16.2,1.2-17.8,15.2S88.1,95,88.1,95s23.8-3.6,19.3-14.2C107.4,80.7,103.1,64.7,88.1,66.5z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  className: "start2",
  d: "M37.6,74.3c0,0,17.8-3.3,30.7,1.9c0,0-6.9,9.1-17,9C51.3,85.2,42.5,83.5,37.6,74.3z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_9_a",
  gradientUnits: "userSpaceOnUse",
  x1: 56.0615,
  y1: 15.919,
  x2: 56.0615,
  y2: 49.5
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.8791
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.659
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.3643
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009855568
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  className: "start13",
  d: "M36.1,49.5c0,0,13.6-10.1,39.9-0.9c0,0-3.4-31.7-6.2-32.7c0,0-1.4,6.2-4.3,7.3c0,0,0.2-4.8-1.1-5.8 c0,0-9.1,6.6-11.9,6.3C52.5,23.8,39.1,30.3,36.1,49.5z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_10_a",
  gradientUnits: "userSpaceOnUse",
  x1: 3.0265,
  y1: 60.7903,
  x2: 39.572,
  y2: 60.7903
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC"
  }
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  className: "start14",
  d: "M39.6,80.7c0,0-8.6-9.1-16.9-0.7c0,0-13.7-4.9-15.5-10.5c0,0-2.8-5.5,2.1-14.3c0,0,11-15.9,10.3-18 c0,0,0.8-1,2.6-2.6c0,0,4.3-6.2-0.9-4.7c0,0-4.9,6.2-6,9.2c0,0-5.2,9.5-6.4,11.2c0,0-8.3,14-5.2,23.4c0,0,0.3,4.6,6.2,8.9 c0,0,5.7,3.3,7.2,9.5c0,0,1.8-6.8,0-8.4c0,0,7.8-0.1,10.3,4.8l-0.2-5.7C27.2,82.7,26.2,76.8,39.6,80.7z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_11_a",
  gradientUnits: "userSpaceOnUse",
  x1: 54.3203,
  y1: 74.6733,
  x2: 54.195,
  y2: 84.9465,
  gradientTransform: "matrix(1.0498 1.280409e-02 1.280409e-02 0.9992 -5.2139 -1.1887)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.8791
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.659
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.3643
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009855568
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  className: "start15",
  d: "M38.9,74.8c0,0,17.2-2.4,27.8,1.8c0,0-7.3,8-15.6,7.8C51.1,84.3,43,82,38.9,74.8z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGID_12_a",
  cx: 101.2258,
  cy: 81.251,
  r: 17.4264,
  gradientTransform: "matrix(0.8873 0 0 1 0 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF",
    stopOpacity: 0.6
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2001,
  style: {
    stopColor: "#FCFDFE",
    stopOpacity: 0.48
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3539,
  style: {
    stopColor: "#F2F8FC",
    stopOpacity: 0.3876
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4924,
  style: {
    stopColor: "#E2F0F9",
    stopOpacity: 0.3046
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6218,
  style: {
    stopColor: "#CBE4F4",
    stopOpacity: 0.2269
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7449,
  style: {
    stopColor: "#ADD4EE",
    stopOpacity: 0.1531
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8633,
  style: {
    stopColor: "#88C1E7",
    stopOpacity: 0.08203065
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9758,
  style: {
    stopColor: "#5DABDE",
    stopOpacity: 0.01449686
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  className: "start16",
  d: "M88.9,67.6c0,0-15.5,1.2-17.1,14.5C70.2,95.6,88.9,95,88.9,95s22.9-3.4,18.5-13.7 C107.4,81.3,103.3,65.9,88.9,67.6z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  className: "start17",
  d: "M74.3,81.6c0,0,9.3-5.3,27.1-4.1L74.3,81.6z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_13_a",
  gradientUnits: "userSpaceOnUse",
  x1: 87.6724,
  y1: 78.955,
  x2: 88.0034,
  y2: 82.1048
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.8791
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.659
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.3643
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009855568
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  className: "start18",
  d: "M74.6,81.6l26.3-4C100.9,77.6,89.4,85,74.6,81.6z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  className: "start2",
  d: "M33.4,56.3c0,0,11.5-14.5,42.6-1l0-5.8c0,0-27.3-4.7-41.9,2.2L33.4,56.3z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  className: "start2",
  d: "M101.4,54c0,16.4,12.5,31.8,23.2,31.8s19.4-13.3,19.4-29.6s-15.6-34-26.3-34S101.4,37.7,101.4,54z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGID_14_a",
  cx: 107.178,
  cy: 55.8279,
  r: 27.0163,
  gradientTransform: "matrix(-0.8873 0 0 1 217.7693 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5549,
  style: {
    stopColor: "#F3F3F3"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#E6E6E6"
  }
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  className: "start19",
  d: "M102.3,53.3c0,15.7,11.9,30.5,22.2,30.5s18.6-12.7,18.6-28.4s-15-32.6-25.2-32.6S102.3,37.6,102.3,53.3z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGID_15_a",
  cx: 106.4199,
  cy: 60.9161,
  r: 17.2351,
  gradientTransform: "matrix(-0.8873 0 0 1 217.7693 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2828,
  style: {
    stopColor: "#F9F9F9"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4304,
  style: {
    stopColor: "#EBEBEC"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5467,
  style: {
    stopColor: "#D9D9DB"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6468,
  style: {
    stopColor: "#C2C3C7"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7364,
  style: {
    stopColor: "#A7A9AE"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8185,
  style: {
    stopColor: "#898C94"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8949,
  style: {
    stopColor: "#6A6F78"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9648,
  style: {
    stopColor: "#4A555E"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#384751"
  }
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  className: "start20",
  cx: 123.3,
  cy: 60.9,
  rx: 15.3,
  ry: 17.2
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGID_16_a",
  cx: 106.3718,
  cy: 60.7789,
  r: 14.349,
  gradientTransform: "matrix(-0.8873 0 0 1 217.7693 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.6609,
  style: {
    stopColor: "#2A3386"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.802,
  style: {
    stopColor: "#65A6DA"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8326,
  style: {
    stopColor: "#69A6D7"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8598,
  style: {
    stopColor: "#74A7CF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8858,
  style: {
    stopColor: "#84A8C4"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9111,
  style: {
    stopColor: "#97A9B4"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9358,
  style: {
    stopColor: "#AEAB9F"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9601,
  style: {
    stopColor: "#C8AD85"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9836,
  style: {
    stopColor: "#E4AE63"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#FBB040"
  }
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  className: "start21",
  cx: 123.4,
  cy: 60.8,
  rx: 12.7,
  ry: 14.3
})), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
  className: "start9",
  cx: 123.8,
  cy: 60.4,
  rx: 8.6,
  ry: 9.7
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_17_a",
  gradientUnits: "userSpaceOnUse",
  x1: 119.0382,
  y1: 67.5533,
  x2: 123.852,
  y2: 59.2155
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1026,
  style: {
    stopColor: "#F0F0F0",
    stopOpacity: 0.8974
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2446,
  style: {
    stopColor: "#E5E5E5",
    stopOpacity: 0.7554
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4447,
  style: {
    stopColor: "#DEDEDE",
    stopOpacity: 0.5553
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#DCDCDC",
    stopOpacity: 0
  }
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  className: "start22",
  d: "M117.2,55.3c0,0-2.5,5,0,10c0,0,2.6,4.1,6.7,3.8c0,0,2.4,0.3,4-1.3c0,0-5,0.6-6.4-1.1c0,0-1.7-0.6-3.5-3.6 C117.9,63.2,116.3,61.7,117.2,55.3z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_18_a",
  gradientUnits: "userSpaceOnUse",
  x1: 122.1299,
  y1: 55.2543,
  x2: 129.7402,
  y2: 55.2543
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#DCDCDC",
    stopOpacity: 0
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#FFFFFF"
  }
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  className: "start23",
  d: "M122.1,51.7c0,0,3.2-1.2,6,1.3c0,0,1.6,1.4,1.6,3.2l-2.6,2.8C127.6,54.8,123.1,52.2,122.1,51.7z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGID_19_a",
  cx: 107.178,
  cy: 53.3198,
  r: 27.0163,
  gradientTransform: "matrix(-0.8873 0 0 1 217.7693 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#FFFFFF",
    stopOpacity: 0.6
  }
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  className: "start24",
  d: "M102.3,53.3c0,15.7,11.9,30.5,22.2,30.5s18.6-12.7,18.6-28.4s-15-32.6-25.2-32.6S102.3,37.6,102.3,53.3z"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  className: "start2",
  d: "M142.8,51.7c0,0-9-10.2-42.4,3.7c0,0,2.7-48.2,9.3-48.2c0,0-1.2,6.5,0.5,9c0,0,0.7-2.7,2.2-4.1 c0,0,10.4,8.4,14,8C126.5,20,139.1,22.7,142.8,51.7z"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  className: "start3",
  d: "M142.2,53.7c0,0-9.1-12.5-40.8,0.7c0,0,3.6-42.6,7-44c0,0-0.4,6,3,7.7c0,0-0.2-2.6,1.3-3.9c0,0,9.9,8,13.3,7.6 C126,21.7,138.6,26.1,142.2,53.7z"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  className: "start2",
  d: "M139.8,73.6c0,0-17.8-3.3-30.7,1.9c0,0,6.9,9.1,17,9C126.1,84.4,134.8,82.8,139.8,73.6z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_20_a",
  gradientUnits: "userSpaceOnUse",
  x1: 124.1031,
  y1: 15.1646,
  x2: 124.1031,
  y2: 48.7456,
  gradientTransform: "matrix(-1 0 0 1 245.4156 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.8791
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.659
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.3643
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009855568
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  className: "start25",
  d: "M141.2,48.7c0,0-13.6-10.1-39.9-0.9c0,0,3.4-31.7,6.2-32.7c0,0,1.4,6.2,4.3,7.3c0,0-0.2-4.8,1.1-5.8 c0,0,9.1,6.6,11.9,6.3C124.9,23.1,138.3,29.5,141.2,48.7z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_21_a",
  gradientUnits: "userSpaceOnUse",
  x1: 119.1515,
  y1: 73.0875,
  x2: 119.0262,
  y2: 83.3608,
  gradientTransform: "matrix(-1.0498 1.280409e-02 -1.280409e-02 0.9992 250.6295 -1.1887)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.8791
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.659
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.3643
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009855568
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  className: "start26",
  d: "M138.5,74c0,0-17.2-2.4-27.8,1.8c0,0,7.3,8,15.6,7.8C126.3,83.6,134.3,81.2,138.5,74z"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  className: "start2",
  d: "M143.9,55.6c0,0-11.5-14.5-42.6-1l0-5.8c0,0,27.3-4.7,41.9,2.2L143.9,55.6z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_22_a",
  gradientUnits: "userSpaceOnUse",
  x1: 27.0542,
  y1: 87.8546,
  x2: 29.8379,
  y2: 87.8546
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.8791
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.659
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.3643
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009855568
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  className: "start27",
  d: "M29.8,93.2c0,0-0.8-10.3-2.8-10.7C27.1,82.5,28.6,88.3,29.8,93.2z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_23_a",
  gradientUnits: "userSpaceOnUse",
  x1: 15.5655,
  y1: 44.894,
  x2: 30.5237,
  y2: 44.894
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.8791
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.659
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.3643
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009855568
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  className: "start28",
  d: "M26.9,24.9l-2.5,2.7c0,0,1.1,1.8,0,4.7c0,0-7.8,11.4-7.8,14.9c0,0-0.6,7.7,4.7,11.7c0,0,3.2,2.9,9.2,5.9 c0,0-8.1-1.9-10.2-4.8c0,0-7.5-7.6-3.7-16.1c0,0,2.6-7.6,5-10.2c0,0,3.1-2.5-0.4-2.2c0,0,1.3-0.5,1.3-1.3c0,0,0.3-0.9-1.3-0.4 c0,0,3.7-4.9,4.7-4.9L26.9,24.9z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_24_a",
  gradientUnits: "userSpaceOnUse",
  x1: 24.0636,
  y1: 74.1339,
  x2: 39.572,
  y2: 74.1339
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.8791
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.659
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.3643
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009855568
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  className: "start29",
  d: "M24.1,68.2c0,0,12.1-5,15.5,12.5C39.6,80.7,36.9,69.2,24.1,68.2z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_25_a",
  gradientUnits: "userSpaceOnUse",
  x1: 22.2381,
  y1: 100.8118,
  x2: 26.5769,
  y2: 100.8118
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.8791
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.659
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.3643
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009855568
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  className: "start30",
  d: "M22.2,94.1c0,0,6.3-0.7,3.7,13.4C26,107.5,27.4,96.3,22.2,94.1z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_26_a",
  gradientUnits: "userSpaceOnUse",
  x1: 17.1239,
  y1: 111.8006,
  x2: 20.4735,
  y2: 111.8006
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.8791
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.659
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.3643
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009855568
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  className: "start31",
  d: "M19.2,122.3c0,0,3.9-7.1-2.1-20.9C17.1,101.3,21.1,113.4,19.2,122.3z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_27_a",
  gradientUnits: "userSpaceOnUse",
  x1: 138.7268,
  y1: 58.9937,
  x2: 159.366,
  y2: 58.9937
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.9516
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.8636
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.7457
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.6039
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0.6
  }
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  className: "start32",
  d: "M148.5,39c1.8,0,1.3,2.4,2.1,2.5c0,0,0.7,2.4-0.4,3.5c0,0,1.5,1.1,2.5,0.5c0,0-1.4,3.4-2,3.5 c0,0,2.8-0.2,5,19.6c0,0-2.8,8.7-6.5,11.5c0,0-0.8,10.1-10.5,14.1c0,0,13.1-3.7,14.4-13.5c0,0,7.2-8.3,6.1-13.2 c0,0-1.6-19.5-4.5-20.3l2-2.7l-2.3-1.4l0-2.7l-2-2.7l-1.9-5.2c0,0-1.9-6.1-3-8.5C147.4,23.9,151.5,37.1,148.5,39z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_28_a",
  gradientUnits: "userSpaceOnUse",
  x1: 28.446,
  y1: 20.0449,
  x2: 57.742,
  y2: 20.0449
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.8791
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.659
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.3643
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009855568
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  className: "start33",
  d: "M41.2,9.6c0,0-8.5,3.7-12.7,13.2c0,0,3.9-0.5,5.6-2.9c0,0-0.8,6.5-3.7,6.5c0,0,8.2-3,8.3-4.3 c0,0-1.7,3.6-1.2,5.4c0,0,0.3-2.2,2-2c0,0-1.1,2.7,0,4.1l1.7-4.1l-0.3,5c0,0,3.2-7,7.3-8.4c0,0,10.3-4,9.5-6.9c0,0-7.6,2.8-11.8,3.2 c0,0,1.4-1.2,0-3.2c0,0-0.6,1.3-2.9,0.8l-4.5,0.7v-2.3l-2.8,1.6C35.8,15.9,37.8,9.6,41.2,9.6z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_29_a",
  gradientUnits: "userSpaceOnUse",
  x1: -42.1516,
  y1: 57.5547,
  x2: -42.1516,
  y2: 57.5547,
  gradientTransform: "matrix(0.3914 -0.7651 0.8212 0.4201 -21.2449 19.2611)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.8791
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.659
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.3643
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009855568
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  className: "start34",
  d: "M9.5,75.7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_30_a",
  gradientUnits: "userSpaceOnUse",
  x1: 162.5007,
  y1: 19.0558,
  x2: 186.8435,
  y2: 19.0558,
  gradientTransform: "matrix(-1 0 0 1 307.3414 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFFFFF"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1209,
  style: {
    stopColor: "#F3F9FD",
    stopOpacity: 0.8791
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.341,
  style: {
    stopColor: "#D2E8F6",
    stopOpacity: 0.659
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6357,
  style: {
    stopColor: "#9DCCEB",
    stopOpacity: 0.3643
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9901,
  style: {
    stopColor: "#55A7DC",
    stopOpacity: 0.009855568
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#53A6DC",
    stopOpacity: 0
  }
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  className: "start35",
  d: "M134.3,9.6c0,0,7.1,3.3,10.6,11.9c0,0-3.3-0.5-4.6-2.6c0,0,0.7,5.9,3.1,5.9c0,0-6.8-2.7-6.9-3.9 c0,0,1.4,3.3,1,4.9c0,0-0.2-2-1.7-1.8c0,0,0.9,2.5,0,3.7l-1.4-3.7l2,4.5c0,0-4.5-6.3-7.9-7.6c0,0-8.5-3.7-7.9-6.2 c0,0,6.3,2.6,9.8,2.9c0,0-1.1-1,0-2.9c0,0,0.5,1.2,2.4,0.7l3.7,0.6v-2.1l2.3,1.5C138.7,15.3,137.1,9.6,134.3,9.6z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgButtonArt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ButtonArt.0def5257.svg";
export { ForwardRef as ReactComponent };